import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import "../../assets/css/Header.css";
import css from "../../assets/css/Nav.module.css";
import BottonMenu from "../uiComponents/BottonMenu";

const w3_close = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");
  if (!sidebar || !overlay) return;
  sidebar.style.left = `-${sidebar.offsetWidth}px`;
  overlay.style.display = "none";
};
const w3_open = () => {
  const sidebar = document.getElementById("mySidebar");
  const overlay = document.getElementById("sidebarOverlay");
  if (!sidebar || !overlay) return;
  sidebar.style.left = "0";
  overlay.style.display = "block";
};

const addsetting = localStorage.getItem("sitSetting");

const addCaseSetting = JSON.parse(addsetting);

const Header = ({ user }) => {
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [isdropdownVisible, setIsdropdownVisible] = useState(false);

  const toggleDiv = () => {
    setIsdropdownVisible(!isdropdownVisible);
  };

  let access_token = localStorage.getItem("token");
  access_token = localStorage.getItem("token");

  const [promptInstall, setPromptInstall] = useState(null);
  const [supportsPWA, setSupportsPWA] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPromptInstall(e);
      setSupportsPWA(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const onClick = (evt) => {
    evt.preventDefault();
    if (!promptInstall) {
      return;
    }
    promptInstall.prompt();
    promptInstall.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
      } else {
      }
      setPromptInstall(null);
    });
  };

  return (
    <>
      <div>
        {access_token ? (
          <React.Fragment>
            <div id="sidebarOverlay" onClick={w3_close}></div>
            <div>
              <div
                className="w3-sidebar w3-bar-block"
                id="mySidebar"
                style={{ paddingBottom: "70px" }}
              >
                <div className="sidebar_header">
                  <Link
                    to={"/landing"}
                    className="sidebar_logo_bar"
                    onClick={w3_close}
                  >
                    <img alt="Logo" src="/logo.png" />
                  </Link>
                  <span className="back_sidebar" onClick={w3_close}>
                    <img alt="Close" src="/images/icons/close.png" />
                  </span>
                </div>

                <Link
                  to={"/profile"}
                  className="w3-bar-item w3-button sidebar_link "
                  onClick={w3_close}
                >
                  <picture className="icon">
                    {user && user?.avatar ? (
                      <img
                        width="30px"
                        height="30px"
                        src={baseUrl + `/${user && user?.avatar}`}
                        alt="profile"
                        style={{ borderRadius: "50px" }}
                      />
                    ) : (
                      <img src="/images/icons/sidebar-user.png" alt="profile" />
                    )}
                  </picture>
                  <h3>My Profile</h3>
                  <img
                    alt=""
                    className="ml-auto"
                    style={{ width: "13px" }}
                    src="/images/icons/right-arrow.png"
                  />
                </Link>

                <Link
                  to={"/Homepage/ludoClassicManual"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img
                      alt="img"
                      src="/images/icons/play-button.png"
                      style={{ height: "22px" }}
                    />
                  </picture>
                  <h3>Play</h3>
                  <img
                    alt=""
                    className="ml-auto"
                    style={{ width: "13px" }}
                    src="/images/icons/right-arrow.png"
                  />
                </Link>
                <Link
                  to={"/wallet"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img alt="img" src="/images/digital-wallet.png" />
                  </picture>
                  <h3>My Wallet</h3>
                  <img
                    alt=""
                    className="ml-auto"
                    style={{ width: "13px" }}
                    src="/images/icons/right-arrow.png"
                  />
                </Link>

                {addCaseSetting?.isReferral ? (
                  <>
                    <Link
                      to={"/refer"}
                      className="w3-bar-item w3-button sidebar_link"
                      onClick={w3_close}
                    >
                      <picture className="icon">
                        <img
                          alt="img"
                          src="/images/icons/digital-marketing.png"
                        />
                      </picture>
                      <h3>Refer and Earn</h3>
                      <img
                        alt=""
                        className="ml-auto"
                        style={{ width: "13px" }}
                        src="/images/icons/right-arrow.png"
                      />
                    </Link>
                  </>
                ) : (
                  ""
                )}

                <Link
                  to={"/history"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img alt="img" src="/images/icons/refresh.png" />
                  </picture>
                  <h3>History</h3>
                  <img
                    alt=""
                    className="ml-auto"
                    style={{ width: "13px" }}
                    src="/images/icons/right-arrow.png"
                  />
                </Link>

                <Link
                  to={"/support"}
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={w3_close}
                >
                  <picture className="icon">
                    <img alt="img" src="/images/technical-support.png" />
                  </picture>
                  <h3>Support</h3>
                  <img
                    alt=""
                    className="ml-auto"
                    style={{ width: "13px" }}
                    src="/images/icons/right-arrow.png"
                  />
                </Link>

                <div
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={toggleDiv}
                >
                  <picture className="icon">
                    <img alt="img" src="/images/insurance.png" />
                  </picture>
                  <h3>{isdropdownVisible ? "All Policy" : "All Policy"}</h3>
                  <img
                    alt=""
                    className="ml-auto"
                    style={{ width: "13px" }}
                    src="/images/icons/right-arrow.png"
                  />
                </div>
                {isdropdownVisible && (
                  <ul className="dropdown_link">
                    <li>
                      <Link to="/privacy-policy" onClick={w3_close}>
                        Privacy Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/term-condition" onClick={w3_close}>
                        Terms &amp; Condition
                      </Link>
                    </li>
                    <li>
                      <Link to="/tds-policy" onClick={w3_close}>
                        TDS Policy
                      </Link>
                    </li>
                    <li>
                      <Link to="/responsible-gaming" onClick={w3_close}>
                        Responsible Gaming
                      </Link>
                    </li>
                    <li>
                      <Link to="/about" onClick={w3_close}>
                        About
                      </Link>
                    </li>
                    <li>
                      <Link to="/contact-us" onClick={w3_close}>
                        Contact
                      </Link>
                    </li>
                  </ul>
                )}

                <div
                  className="w3-bar-item w3-button sidebar_link"
                  onClick={onClick}
                  style={{ background: "", fontWeight: "bold" }}
                >
                  <picture className="icon">
                    <img alt="img" src="../images/icons/downloading.png" />
                  </picture>
                  <h3 style={{ fontWeight: "bold" }}>
                    {isdropdownVisible ? " App Download" : " App Download"}
                  </h3>
                </div>
              </div>
            </div>

            <div>
              <div className="w3-container">
                <div className={css.headerContainer}>
                  <div className="menu_logo">
                    <button
                      className="menu_button"
                      onClick={w3_open}
                      id="hambergar"
                      aria-label="Toggle menu"
                    >
                      <img alt="Menu" src="/images/menu.png" />
                    </button>
                    <Link to="/">
                      <img
                        src="/logo.png"
                        className="snip-img"
                        alt="Logo"
                        style={{ height: "50px", width: "auto" }}
                      />
                    </Link>
                  </div>

                  <div className="top_menu_bar_main">
                    <nav className={css.menu_items}>
                      <div className="header_navlink_main ml-0">
                        <NavLink
                          exact
                          to="/addcase"
                          className="wallet_balance_btn"
                          activeClassName=""
                          title="Add Cash"
                        >
                          <img
                            alt="Rewards"
                            className="header_img_wallet"
                            onClick={w3_close}
                            src="/images/icons/rupee-icon.png"
                          />

                          <span> ₹{user ? user?.Wallet_balance : 0}</span>
                          <span className="wallet_add_icon">+</span>
                        </NavLink>
                      </div>

                      <div className="header_navlink_main">
                        <NavLink
                          exact
                          to="/redeem/refer"
                          className="wallet_balance_btn wallet_btn ml-1"
                          activeClassName=""
                          title="Referral Rewards"
                        >
                          <img
                            alt="Rewards"
                            className="header_img_wallet"
                            onClick={w3_close}
                            src="/images/icons/prize.png"
                          />
                          <span>
                            {" "}
                            ₹
                            {user
                              ? Number(user.referral_wallet || 0).toFixed(2)
                              : "0.00"}
                          </span>
                        </NavLink>
                      </div>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        ) : (
          <div>
            <div className="w3-container">
              <div className={`${css.headerContainer} justify-content-between`}>
                <Link to="/">
                  <picture className={`ml-2 ${css.navLogo} d-flex`}>
                    <img
                      src="/logo.png"
                      className="snip-img"
                      alt="Logo"
                      style={{ height: "50px", width: "auto" }}
                    />
                  </picture>
                </Link>

                <div>
                  <Link type="button" className="login-btn" to="/login">
                    LOGIN
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      <div className="bottom_menus_main">
        <BottonMenu w3_close={w3_close} />
      </div>
    </>
  );
};

export default Header;
